import {getRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des formes juridiques.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getLegalFormList = (token) => {
    const url = `/api-v1/admin/legalform/list`;
    return getRequest(url, token)
}